// @flow
import * as React from 'react';
import {CommunityNotLogin} from "communitypage/qna/popup/qna-popup-style";
import {SsqImages} from "images/SsqImages";

type Props = { trans, doLogin };
export const NoLoginAnswerWrite = ({trans, ...props}: Props) => {
  return (
    <div className="content write">
      <CommunityNotLogin>
        <div className="qna-check">
          <div className="icon-qna red-a"></div>
        </div>
        <div className="not-login">
          <div className="left">
            <img alt={"error_login.svg"} src={SsqImages.common.loginError()}/>
          </div>
          <div className="right">
            <p className="title-lg">{trans('I18N_COMMUNITY_QNA_LOGIN_STRING1')}</p>
            <p className="title-sm">{trans('I18N_COMMUNITY_QNA_LOGIN_STRING2')}</p>
            <button className="mem-status-btn" onClick={() => {
              props.doLogin();
            }}>{trans('I18N_COMMUNITY_QNA_LOGIN_STRING3')}</button>
          </div>
        </div>

      </CommunityNotLogin>
    </div>
  );
};